import Image from "next/image";
import {cn} from "@/lib/utils";

export function Backdrop({className, blendArtwork = false}: {className?: string; blendArtwork?: boolean}) {
  if (blendArtwork) {
    return <div className={cn("relative h-full w-full", className)}>
      <div
        className="absolute inset-y-0 right-0 w-[calc(200%+1rem)] overflow-hidden rounded-r-lg bg-black"
        style={leftFadeMask}
      >
        <div className="absolute inset-x-0 bottom-0 h-[58%]" style={topFadeMask}>
          <Image src="/backdrop.png" alt="backdrop" fill sizes="50vw" className="object-fill"/>
        </div>
        <FadeDither/>
      </div>
      <div className="relative flex h-1/2 items-end justify-center pb-4">
        <Image
          src="/logo-wordmark-white.svg"
          alt="Devplan"
          width={254}
          height={70}
          priority
          className="h-[70px] w-auto"
        />
      </div>
    </div>
  }

  return <div className={cn("flex flex-col h-full w-full bg-black rounded-lg", className)}>
    <div className="flex-1 flex items-end justify-center pb-4">
      <Image
        src="/logo-wordmark-white.svg"
        alt="Devplan"
        width={254}
        height={70}
        priority
        className="h-[70px] w-auto"
      />
    </div>
    <div className="flex-1 flex items-start justify-center w-full">
      <Image src="/backdrop.png" alt="backdrop" height={156} width={302} className="w-full"/>
    </div>
  </div>
}

const leftFadeMask = {
  maskImage: "url('/signin-fade-mask.svg')",
  maskRepeat: "no-repeat",
  maskSize: "100% 100%",
  WebkitMaskImage: "url('/signin-fade-mask.svg')",
  WebkitMaskRepeat: "no-repeat",
  WebkitMaskSize: "100% 100%",
}

const topFadeMask = {
  maskImage: "linear-gradient(to bottom, transparent 0%, black 20%, black 100%)",
  WebkitMaskImage: "linear-gradient(to bottom, transparent 0%, black 20%, black 100%)",
}

function FadeDither() {
  return <svg
    aria-hidden="true"
    className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.025] mix-blend-soft-light"
  >
    <filter id="signin-fade-dither">
      <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="2" seed="7" stitchTiles="stitch"/>
    </filter>
    <rect width="100%" height="100%" filter="url(#signin-fade-dither)"/>
  </svg>
}
